import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { JobRepairDataDto } from './job-repair-data.dto';
import { JobRepairBuilderSupervisorEmailInterface } from '../interfaces/job-repair-builder-supervisor-email.interface';

export class JobRepairBuilderSupervisorEmailDto
  implements JobRepairBuilderSupervisorEmailInterface
{
  @ApiProperty({
    type: 'string',
    isArray: true,
    title: 'Builder Supervisor Emails',
    description:
      'A list of email addresses of builder supervisors associated with a specific job repair',
  })
  @Expose()
  to!: string[];

  @ApiProperty({
    type: () => JobRepairDataDto,
    title: 'Job Repair Data',
    description:
      'Contains detailed information about the job repair. This information is utilized to ' +
      'construct and personalize emails sent through an email client.',
  })
  @Expose()
  jobRepairData!: JobRepairDataDto;
}
